import {useReducer, useState} from 'react'
import {formReducer, initialState,ACTION_TYPES} from '../useReducer/formReducer'

function FormReducer() {

    const [state,dispatch ] = useReducer(formReducer ,initialState )
    const [tags, setTags] = useState('')

    return (
        <div className='container'>
            <p>FormReducer</p>
            <p>{initialState.title}</p>
            <div className="row">
                <div className="col-9">
                    <form>
                        <div className="form-group mb-3">
                            <input name='title' onChange={(e) => dispatch({type: ACTION_TYPES.CHANGE_INPUT,data:e.target})} type="text"
                                   className="form-control" placeholder="عنوان"/>
                        </div>
                        <div className="form-group mb-3">
                            <input name='description' type="text" className="form-control" onChange={(e) => dispatch({type: ACTION_TYPES.CHANGE_INPUT,data:e.target})} placeholder="توضیح"/>
                        </div>
                        <div className="form-group mb-3">
                            <input name='price' type="number" className="form-control" onChange={(e) => dispatch({type: ACTION_TYPES.CHANGE_INPUT,data:e.target})} placeholder="قیمت"/>
                        </div>
                        <div className="form-group mb-3">
                            <select name='category' onChange={(e) => dispatch({type: ACTION_TYPES.CHANGE_INPUT,data:e.target})}>
                                <option value='bag'>کیف</option>
                                <option value='shoes'> کفش</option>
                                <option value='dress'>لباس</option>
                            </select>
                        </div>
                        <div className="form-group mb-3">
                            <textarea name='tag' placeholder='tag....' onChange={(e)=>setTags(e.target.value)}></textarea>
                            <button type="button" className="btn btn-success mx-2 " onClick={()=>dispatch({type:ACTION_TYPES.ADD_TAG,data:tags})}>انتخاب تگ</button>
                            {state.tags.map((t,index)=>{
                                return <button onClick={()=>dispatch({type:ACTION_TYPES.REMOVE_TAG,data: {tag:t,index:index}})} type='button' className="btn btn-warning mx-1" key={index}>{t}</button>
                            })}
                        </div>
                        <div className="form-group mb-3">
                            <button type="button" className="btn btn-success mx-2" onClick={()=>dispatch({type:ACTION_TYPES.INCREASE})}>+</button>
                            <span  >{state.quantity} </span>
                            <button type="button" className="btn btn-success mx-2" onClick={()=>{dispatch({type:ACTION_TYPES.DECREASE})}}>-</button>
                        </div>
                        <hr/>
                        <div className="form-group mb-3">
                            <button type="button" className="btn btn-info mx-2    ">send</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default FormReducer
